export var SET_INITIAL_SCREEN = 'SET_INITIAL_SCREEN';
export var SHOW_NEXT = 'SHOW_NEXT';
export var SHOW_PREVIOUS = 'SHOW_PREVIOUS';
export var SHOW_HOME = 'SHOW_HOME';
export var SHOW_SCREEN = 'SHOW_SCREEN';
export var SET_SCREEN_TRANSITION = 'SET_SCREEN_TRANSITION';
export var SCREEN_RESIZED = 'SCREEN_RESIZED';
export var IMAGE_LOADED = 'IMAGE_LOADED';
export var IMAGE_LOAD_FAILED = 'IMAGE_LOAD_FAILED';
export var SCROLL_TO = 'SCROLL_TO';
export var UNSET_SCROLL_POS = 'UNSET_SCROLL_POS';
export var SCREEN_TIMER = 'SCREEN_TIMER';
export var SCREEN_TRANSITION_COMPLETED = 'SCREEN_TRANSITION_COMPLETED';
export var SHOW_SCREEN_INFO = 'SHOW_SCREEN_INFO';
export var HIDE_SCREEN_INFO = 'HIDE_SCREEN_INFO';
export var GIF_RESET_DONE = 'GIF_RESET_DONE';
export var SHOW_HOVER_SCREEN = 'SHOW_HOVER_SCREEN';
